import {RPCDocs} from '@therms/rpc-gateway'
import dayjs from 'dayjs'

/**
 * Check if a location task todo can be completed based on its allowedEarliest and allowedLatest properties.
 * @param locationTaskTodo
 */
export function checkLocationTaskTodoCanComplete(
  locationTaskTodo: Pick<
    RPCDocs.Locations.GetLocationTaskTodos.v1.LocationTaskTodo,
    'allowedLatest' | 'allowedEarliest' | 'dueDate' | 'status'
  >,
) {
  const {allowedEarliest, allowedLatest, dueDate, status} = locationTaskTodo
  const now = new Date().toISOString()

  const isPending =
    status === RPCDocs.Locations.GetLocationTaskTodos.v1.Status.Pending

  if (!dueDate && !allowedEarliest && !allowedLatest && isPending) {
    return {canComplete: true}
  }

  if (!isPending) {
    return {
      canComplete: false,
      message: `Task already ${status}`,
      reason: 'already_completed' as const,
    }
  }

  if (
    (allowedEarliest && now <= allowedEarliest) ||
    (!allowedEarliest && dueDate && now <= dueDate)
  ) {
    return {
      canComplete: false,
      message: `It's too early to complete this task`,
      minAway: dayjs(allowedEarliest).diff(dayjs(), 'minute'),
      reason: 'too_early' as const,
    }
  }

  if (
    (allowedLatest && now >= allowedLatest) ||
    (!allowedLatest && dueDate && now > dueDate)
  ) {
    return {
      canComplete: false,
      message: `It's too late to complete this task`,
      minPast: dayjs().diff(dayjs(allowedLatest), 'minute'),
      reason: 'too_late' as const,
    }
  }

  return {canComplete: true}
}
